import { render, staticRenderFns } from "./404.vue?vue&type=template&id=5bc07b5e"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=5bc07b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports